import { baseApi as api } from "./baseApi";
var injectedRtkApi = api.injectEndpoints({
    endpoints: function (build) { return ({
        getAccounts: build.query({
            query: function (queryArg) { return ({
                url: "/accounts",
                params: {
                    subdomain: queryArg.subdomain,
                },
            }); },
        }),
        getAccount: build.query({
            query: function (queryArg) { return ({ url: "/accounts/".concat(queryArg.accountId) }); },
        }),
        getChapterDefinitions: build.query({
            query: function (queryArg) { return ({
                url: "/accounts/".concat(queryArg.accountId, "/chapter_definitions"),
            }); },
        }),
        getFormTemplate: build.query({
            query: function (queryArg) { return ({
                url: "/accounts/".concat(queryArg.accountId, "/form_templates/").concat(queryArg.formTemplateId),
            }); },
        }),
        getStudyArms: build.query({
            query: function (queryArg) { return ({
                url: "/accounts/".concat(queryArg.accountId, "/protocols/").concat(queryArg.studyProtocolId, "/study_arms"),
            }); },
        }),
        getStudyProcedureDefinitions: build.query({
            query: function (queryArg) { return ({
                url: "/accounts/".concat(queryArg.accountId, "/protocols/").concat(queryArg.studyProtocolId, "/study_procedure_definitions"),
            }); },
        }),
        getStudyProtocols: build.query({
            query: function (queryArg) { return ({
                url: "/accounts/".concat(queryArg.accountId, "/protocols"),
            }); },
        }),
        getProtocolsReporting: build.query({
            query: function (queryArg) { return ({
                url: "/accounts/".concat(queryArg.accountId, "/protocols/").concat(queryArg.studyProtocolId, "/site_reporting"),
                params: {
                    page: queryArg.page,
                },
            }); },
        }),
        getProtocolsReportingExport: build.query({
            query: function (queryArg) { return ({
                url: "/accounts/".concat(queryArg.accountId, "/protocols/").concat(queryArg.studyProtocolId, "/site_reporting/export"),
            }); },
        }),
    }); },
    overrideExisting: false,
});
export { injectedRtkApi as accountsApi };
export var useGetAccountsQuery = injectedRtkApi.useGetAccountsQuery, useGetAccountQuery = injectedRtkApi.useGetAccountQuery, useGetChapterDefinitionsQuery = injectedRtkApi.useGetChapterDefinitionsQuery, useGetFormTemplateQuery = injectedRtkApi.useGetFormTemplateQuery, useGetStudyArmsQuery = injectedRtkApi.useGetStudyArmsQuery, useGetStudyProcedureDefinitionsQuery = injectedRtkApi.useGetStudyProcedureDefinitionsQuery, useGetStudyProtocolsQuery = injectedRtkApi.useGetStudyProtocolsQuery, useGetProtocolsReportingQuery = injectedRtkApi.useGetProtocolsReportingQuery, useGetProtocolsReportingExportQuery = injectedRtkApi.useGetProtocolsReportingExportQuery;
